<template>
    <div class="eu-tyre-label">
        <div class='item--primary container'>
            <div class='xs-12 bg-white'>
                <div class='xs-mt-2'>
                    <!-- <h2>EU Bandenlabel</h2> -->
                    <div class='tire-label'>
                        <div class='tire-label__header'>
                            <div class='tire-label__header-logo'>
                                <img alt="energy logo" class="tire-label__logo"
                                    src="../../public/eutyrelabelgen/image/energy-logo.svg" />
                            </div>
                            <!-- <div class='tire-label__qr-code js_qr-code' data-qr-link="`https://eprel.ec.europa.eu/qr/${eprel_id}`"
                                data-qr-size='120'></div> -->

                            <qrcode-vue v-if="eprel_id" :value="`https://eprel.ec.europa.eu/qr/${eprel_id}`" :size="40"></qrcode-vue>

                        </div>
                        <div class='tire-label__content'>
                            <div class='tire-label__line tire-label__border tire-label__border--horizontal'>
                                <p class='tire-label__text'>
                                    <b>{{brand_name}}</b>
                                </p>
                                <p class='tire-label__text'>
                                    {{manufacturer_product_id}}
                                </p>
                            </div>
                            <div class='tire-label__line tire-label__border tire-label__border--horizontal'>
                                <p class='tire-label__text tire-label__text--large'>
                                    {{width}}/{{aspect_ratio}}R{{diameter}} {{update_load_index}} {{update_speed_index}}
                                </p>
                                <p class='tire-label__text'>
                                    {{tyre_class}}
                                </p>
                            </div>
                            <div class='tire-label__row'>
                                <div class='tire-label__col tire-label__border tire-label__border--vertical'>
                                    <img alt="fuel icon" class="tire-label__type-icon"
                                        src="../../public/eutyrelabelgen/image/fuel-icon.svg" />
                                    <div class='tire-label__pointer-container'>
                                        <img alt="scale color" class="tire-label__scale-icon"
                                            src="../../public/eutyrelabelgen/image/scale-color.svg" />
                                        <div class='tire-label__pointer' :data-state='fuel_effiency'>
                                            <p class='tire-label__pointer-text'>{{fuel_effiency}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class='tire-label__col'>
                                    <img alt="grip icon" class="tire-label__type-icon"
                                        src="../../public/eutyrelabelgen/image/grip-icon.svg" />
                                    <div class='tire-label__pointer-container'>
                                        <img alt="scale blue" class="tire-label__scale-icon"
                                            src="../../public/eutyrelabelgen/image/scale-blue.svg" />
                                        <div class='tire-label__pointer' :data-state='wet_grip'>
                                            <p class='tire-label__pointer-text'>{{wet_grip}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class='tire-label__border-bottom tire-label__border tire-label__border--horizontal'></div>
                        </div>
                        <div class='tire-label__footer'>
                            <p class='tire-label__footer-text'>2020/740</p>
                            <div class='relative'>
                                <!-- <img alt="sound icon" class="tire-label__footer-icon"
                                    src="../../public/eutyrelabelgen/image/sound-icon-b.svg" /> -->
                                <img alt="sound icon" class="tire-label__footer-icon"
                                    src="../../public/eutyrelabelgen/image/icon.rolling-noise.png" />
                                <p class='tire-label__noise-level'>{{noice_value}} db</p>
                                
                                <p class='tire-label__noise-value'>
                                    <span :class="{ 'tire-label__noise-value-active' : noice_value < 69 }">A</span>
                                    <span :class="{ 'tire-label__noise-value-active' : noice_value >= 69 && noice_value < 73 }">B</span>
                                    <span :class="{ 'tire-label__noise-value-active' : (!(noice_value < 69) && !(noice_value >= 69 && noice_value < 73 ) ) }">C</span>
                                </p>
                                
                            </div>
                            <img v-if="snow_grip == '1'" alt="snow icon" class="tire-label__footer-icon tire-label__footer-icon--small"
                                src="../../public/eutyrelabelgen/image/snow-icon.svg" />
                            <img v-if="ice_grip == '1'" alt="snow icon" class="tire-label__footer-icon tire-label__footer-icon--small"
                                src="../../public/eutyrelabelgen/image/ice-grip.png" />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<style scoped src="./../../public/eutyrelabelgen/css/jquery.rating.css"></style>
<style scoped src="./../../public/eutyrelabelgen/css/application.css"></style>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
    data() {
        return {
            update_load_index: "",
            update_speed_index: ""
        }
    },
    components: {
        QrcodeVue,
    },
    props: ['noice_value', 'wet_grip', 'fuel_effiency', 'tyre_class', 'width', 'aspect_ratio', 'diameter', 'load_index', 'speed_index', 'brand_name', 'manufacturer_product_id', 'eprel_id', 'snow_grip', 'ice_grip', 'reinforced'],
    created: function () {
        
        if(this.load_index) {
            this.update_load_index = this.load_index.split(" ")[0];
        }

        if(this.speed_index) {
            this.update_speed_index = this.speed_index.split(" ")[0];
        }
    }
}
</script>
<style scoped>
.xs-mt-2{
  margin-top: 16px;
  margin-left: -30px;
}

.tire-label{
    border: 2px solid;
}
</style>

  


